import React from 'react';
import { ParkingProductCardShimmer } from './card/ParkingProductCardShimmer';

export const AvailabilityResultsShimmer = () => (
	<>
		<ParkingProductCardShimmer />
		<ParkingProductCardShimmer />
		<ParkingProductCardShimmer />
	</>
);
